import React, { Component } from 'react'

export default class FullScreeenAlert extends Component {

	exit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		this.props.onExit();
	}

	render() {
		return (
			<div className="full-screen" onClick={this.exit} >
				<div className="card card-colored shadow">
					<div className="card-body text-center">
						<h5 className="card-title">
							Error
						</h5>
						<p>{this.props.message || 'Prišlo je do napake'}</p>
					</div>
					<ul id="SelectClass-btns" className="mb-4">
					<li onClick={this.exit} className="btn btn-outline-primary" >{this.props.buttonText}</li>
					</ul>
				</div>
			</div>

		)
	}
}